import { Avatar, Box, Flex, keyframes } from '@chakra-ui/react';
import rr from "../Assets/Img/rr2.jpg"

export default function NewAvatar() {
  const size = '300px';
  const color = 'teal.300';

  const pulseRing = keyframes`
	0% {
    transform: scale(0.33);
  }
  40%,
  50% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
	`;

  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      h="400px"
      w="full"
      overflow="hidden">
      {/* Ideally, only the box should be used. The <Flex /> is used to style the preview. */}
      <Box
        as="div"
        position="relative"
        w={size}
        h={'90%'}
        _before={{
          content: "''",
          position: 'relative',
          display: 'block',
          width: '300%',
          height: '260%',
          boxSizing: 'border-box',
          marginLeft: '-100%',
          marginTop: '-100%',
          borderRadius: '100%',
          bgColor: color,
          animation: `2.25s ${pulseRing} cubic-bezier(0.455, 0.03, 0.515, 0.955) -0.4s infinite`,
        }}>
        <Avatar
          src={rr}  
          size="full"
          position="absolute"
          top={0}
        />
      </Box>
    </Flex>

  );
}